import { makeStyles } from "@material-ui/core";

const ItemListaDespesaGroupPayStyles = makeStyles(() => ({
  containerItemDespesa: {
    marginTop: "5vh",
    border: "1px solid #eeeeee",
    borderRadius: "10px",
    alignItems: "flex-start",
  },
  headerTipoENome: {
    display: "flex"
  },
  sessaoTipoDespesa: {
    padding: 5,
    textAlign: "center",
    fontWeight: "bold",
    borderTopLeftRadius: 5,
    marginRight: 5,
    justifyContent: "center"
  },
  tipoDespesaEmail: {
    backgroundColor: "#DDDDF8",
    color: "#4D5BB1",
  },
  tipoDespesaIA: {
    backgroundColor: "#ACEAB6",
    color: "#178571",
  },
  sessaoNomeCondominio: {
    padding: 5,
    fontWeight: 550,
    fontSize: 15
  },
  sessaoBotoes :{
    display: "flex", 
    position: "relative",
    justifyContent: "flex-end", 
    padding: 10, 
    gap: 10
  },
  linhaInf: {
    display: "flex", 
    padding: 10
  },
  camposInf: {
    display: "flex", 
    flexDirection: "column"
  },
  textoDestaque: {
    fontWeight: 550,
    fontSize: 15
  },
  labels: {
    fontSize: 13, 
    color: "#9F9F9F"
  },
  campoTipoNota: {
    fontWeight: 550,
    fontSize: 15,
    backgroundColor: "#1C84C65E",
    borderRadius: 50,
    paddingLeft: 10,
    paddingRight: 10,
    textAlign: "center",
    justifyContent: "center",
  },
  labelDespesaExluida: {
    color: "#ED5565B0", 
    fontWeight: 550
  }
}));

export default ItemListaDespesaGroupPayStyles;